import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';

export const OBJECT_BASE_FRAGMENT = gql`
  fragment ObjectBaseFragment on Object {
    id
    name
    createdByManufacturer
    objectNumber
    address {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`;
